import { Modal } from "@xola/ui-kit";
import React from "react";
import {
    AcceptOrDeclinePurchaseModalForm,
    AcceptOrDeclinePurchaseModalFormProps,
} from "./AcceptOrDeclinePurchaseModalForm";
import { purchaseTypeActions } from "./helpers";

interface AcceptOrDeclinePurchaseModalProps extends AcceptOrDeclinePurchaseModalFormProps {
    isOpen: boolean;
}

export const AcceptOrDeclinePurchaseModal = ({
    isOpen,
    onClose,
    updatedStatus,
    ...rest
}: AcceptOrDeclinePurchaseModalProps) => {
    return (
        <Modal isOpen={isOpen} className="overflow-visible" onClose={onClose}>
            <Modal.Header>{purchaseTypeActions[updatedStatus].title} Reservation</Modal.Header>

            <AcceptOrDeclinePurchaseModalForm updatedStatus={updatedStatus} onClose={onClose} {...rest} />
        </Modal>
    );
};
